import { otpVerificationState } from '~/store/otp-verification/initialState.ts';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  generateOtpForRegistration,
  generateOtpForVerification,
} from './thunks/generateOtpThunks.ts';
import { otpFulfilled, otpPending } from '~/store/otp-verification/actions/generateOtpActions.ts';
import { validateOtp } from '~/store/otp-verification/thunks/validOtpThunks.ts';
import {
  ValidOtpFulfilled,
  ValidOtpPending,
} from '~/store/otp-verification/actions/validOtpActions.ts';
import {
  getVerificationStatusRevoke,
  getVerificationStatusSubmit,
} from './thunks/personalDataVerificationThunks.ts';
import {
  personalDataVerificationFulfilled,
  personalDataVerificationPending,
} from './actions/personalDataVerificationActions.ts';
import { otpError } from '~/store/otp-verification/actions/actions.ts';
import {
  otpVerificationCheckRemoteBankingContacts,
  otpVerificationStatusRemoteBankingContacts,
} from '~/store/otp-verification/thunks/otpVerificationStatusThunks.ts';
import {
  otpVerificationStatusActionsFulfilled,
  otpVerificationStatusActionsPending,
} from '~/store/otp-verification/actions/otpVerificationStatusActions.ts';

const otpSlice = createSlice({
  name: 'otpVerification',
  initialState: otpVerificationState,
  reducers: {
    clearOtpState(state) {
      state = otpVerificationState;
    },
    setOtpError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateOtpForRegistration.pending, otpPending)
      .addCase(generateOtpForRegistration.fulfilled, otpFulfilled)
      .addCase(generateOtpForRegistration.rejected, otpError)

      .addCase(generateOtpForVerification.pending, otpPending)
      .addCase(generateOtpForVerification.fulfilled, otpFulfilled)
      .addCase(generateOtpForVerification.rejected, otpError)

      .addCase(validateOtp.pending, ValidOtpPending)
      .addCase(validateOtp.fulfilled, ValidOtpFulfilled)
      .addCase(validateOtp.rejected, otpError)

      .addCase(getVerificationStatusSubmit.fulfilled, personalDataVerificationFulfilled)
      .addCase(getVerificationStatusSubmit.pending, personalDataVerificationPending)
      .addCase(getVerificationStatusSubmit.rejected, otpError)

      .addCase(getVerificationStatusRevoke.fulfilled, personalDataVerificationFulfilled)
      .addCase(getVerificationStatusRevoke.pending, personalDataVerificationPending)
      .addCase(getVerificationStatusRevoke.rejected, otpError)

      .addCase(
        otpVerificationStatusRemoteBankingContacts.fulfilled,
        otpVerificationStatusActionsFulfilled
      )
      .addCase(
        otpVerificationStatusRemoteBankingContacts.pending,
        otpVerificationStatusActionsPending
      )
      .addCase(otpVerificationStatusRemoteBankingContacts.rejected, otpError)

      .addCase(
        otpVerificationCheckRemoteBankingContacts.fulfilled,
        otpVerificationStatusActionsFulfilled
      )
      .addCase(
        otpVerificationCheckRemoteBankingContacts.pending,
        otpVerificationStatusActionsPending
      )
      .addCase(otpVerificationCheckRemoteBankingContacts.rejected, otpError);
  },
});

export const { clearOtpState, setOtpError } = otpSlice.actions;

export default otpSlice.reducer;
